/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export const LoyaltyCardStatus = {
	Active: 'ACTIVE',
	Inactive: 'INACTIVE',
	Blocked: 'BLOCKED'
} as const
export type LoyaltyCardStatusType = (typeof LoyaltyCardStatus)[keyof typeof LoyaltyCardStatus]
export type LoyaltyCard = {
	uuid: string
	name: string
	cardNumber: string
	status: LoyaltyCardStatusType
	customer?: {
		uuid: string
		firstName?: string
		lastName?: string
		email?: string
	}
	availablePoints: number
	totalPoints?: number
	externalId?: string
	externalSource?: string
	createdAt: number
	updatedAt: number
}
export type LoyaltyCardRedemption = {
	uuid: string
	pointsUsed: number
	pointsRemaining: number
	status: string
	orderUuid: string
	orderDisplayId?: number
	createdAt: number
}

export const zLoyaltyCardStatus = z.enum(['ACTIVE', 'INACTIVE', 'BLOCKED'])
export const zLoyaltyCard = z.object({
	uuid: z.string(),
	name: z.string(),
	cardNumber: z.string(),
	status: zLoyaltyCardStatus,
	customer: z
		.object({
			uuid: z.string(),
			firstName: z.string().optional(),
			lastName: z.string().optional(),
			email: z.string().optional()
		})
		.optional(),
	availablePoints: z.number(),
	totalPoints: z.number().optional(),
	externalId: z.string().optional(),
	externalSource: z.string().optional(),
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zLoyaltyCardRedemption = z.object({
	uuid: z.string(),
	pointsUsed: z.number(),
	pointsRemaining: z.number(),
	status: z.string(),
	orderUuid: z.string(),
	orderDisplayId: z.number().optional(),
	createdAt: z.number()
})
